import styled from "styled-components";

export const GMAPContainer = styled.div`
  display: block;
  box-sizing: border-box;
  padding: 0;
`